import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';

/**
 * Разрешения для медиа запросов в css
 *
 * @name data.BREAKPOINTS
 * @type {Record<String string>}
 */
export const BREAKPOINTS = {
    desktop: '1599px',
    sDesktop: '1390px',
    laptop: '1279px',
    tablet: '1080px',
    mobile: '760px',
};

type TTABS = {
    apartment: string,
    house: string,
    countryHouse: string,
}

export const homeInternetTabs: TTABS =
{
    apartment: 'В квартире',
    house: 'За городом',
    countryHouse: 'На дачу',
};

interface IFastData {
    id: number,
    initialTypeIsRow?: boolean,
    imgUrl: string,
    webpUrl?: string,
    title: string,
    subText: string,
}

export interface IHomeData extends IFastData {
    color: string,
}

type THomeData = Omit<IHomeData, 'imgUrl'>;

type TImg = {
    absoluteImgOne: string,
    absoluteImgTwo: string,
    absoluteImgThree: string,
    background: string,
}

type TMiniBannersData = TImg & THomeData;

export const fastInternetDataCountryHouse: IFastData[] = [
    {
        id: 1,
        initialTypeIsRow: true,
        imgUrl: require('~/static/images/block-internet/hand.png'),
        title: 'Объединить близких',
        subText: 'Wi-Fi в&nbsp;доме&nbsp;&mdash; это мультфильмы для детей, возможность работать удалённо и&nbsp;круглосуточный доступ к&nbsp;онлайн-развлечениям для всей семьи',
    },
    {
        id: 2,
        imgUrl: require('~/static/images/block-internet/devices.png'),
        title: 'Подключить до&nbsp;12&nbsp;устройств одновременно',
        subText: 'Cмартфон, телевизор, ноутбук, видеонаблюдение и&nbsp;устройства умного дома',
    },
    {
        id: 3,
        imgUrl: require('~/static/images/block-internet/wifi.png'),
        title: 'Быть на&nbsp;связи в&nbsp;любом уголке дома',
        subText: 'Отличный сигнал в&nbsp;каждом уголке дома, а&nbsp;также на&nbsp;крыше и&nbsp;во&nbsp;дворе',
    },
];

export const fastInternetData: IFastData[] = [
    {
        id: 1,
        initialTypeIsRow: true,
        imgUrl: require('~/static/images/block-internet/hand.png'),
        title: 'Объединяет семью и друзей',
        subText: 'Включите ребенку мультик, пока проводите онлайн-совещание, ' +
            'а заодно поставьте скачиваться свежий сериал — интернета хватит на всё',
    },
    {
        id: 2,
        imgUrl: require('~/static/images/block-internet/devices.png'),
        title: 'Позволяет подключить до 12 устройств одновременно',
        subText: 'Cмартфон, телевизор, ноутбук, а заодно и умный чайник',
    },
    {
        id: 3,
        imgUrl: require('~/static/images/block-internet/wifi.png'),
        title: 'Ловит там, где вы',
        subText: 'И не зависает по всей квартире: на кухне, на балконе, в любимом месте и даже в ванной',
    },
];

export const homeInternetData: IHomeData[] = [
    {
        id: 1,
        initialTypeIsRow: true,
        imgUrl: require('~/static/images/block-internet/tv.jpg'),
        title: 'Без зависаний на самом интересном моменте',
        subText: 'А&nbsp;качество Full HD&nbsp;позволит с&nbsp;головой окунуться в&nbsp;атмосферу фильма.',
        color: `${COLORS.black}`,
    },
    {
        id: 2,
        imgUrl: require('~/static/images/block-internet/remotejob.jpg'),
        title: 'Эффективная удаленка',
        subText: 'Без неловких пауз на&nbsp;видеконференциях. ' +
            'Не&nbsp;пропустите ни&nbsp;одной детали и&nbsp;увидите все отчеты. И&nbsp;вас увидят. Если захотите.',
        color: `${COLORS.black}`,
    },
    {
        id: 3,
        imgUrl: require('~/static/images/block-internet/study.jpg'),
        title: 'Подключитесь и учитесь',
        subText: 'Тяжелые файлы, вебинары в&nbsp;прямом эфире, методички, курсовые и&nbsp;отчеты&nbsp;&mdash; загрузится все.',
        color: `${COLORS.black}`,
    },
    {
        id: 4,
        imgUrl: require('~/static/images/block-internet/game.jpg'),
        title: 'Играйте главную роль',
        subText: 'Не&nbsp;подводите команду на&nbsp;важной миссии: спасайте мир и&nbsp;защищайте другие цивилизации в&nbsp;онлайн-играх.',
        color: `${COLORS.black}`,
    },
    {
        id: 5,
        imgUrl: require('~/static/images/block-internet/smarthome.jpg'),
        title: 'Управляйте умными устройствами',
        subText: 'Включайте чайник из спальни, запускайте робот-пылесос, попросите умную колонку включить музыку под настроение.',
        color: `${COLORS.black}`,
    },
];

export const villageInternetData: IHomeData[] = [
    {
        id: 1,
        initialTypeIsRow: true,
        imgUrl: require('~/static/images/block-internet/tv.jpg'),
        title: 'Кинотеатр в загородном доме',
        subText: 'Смотрите кино в таком же разрешении, как и в городской квартире. ',
        color: `${COLORS.black}`,
    },
    {
        id: 2,
        imgUrl: require('~/static/images/block-internet/garden.jpg'),
        title: 'Прощай, город!',
        subText: 'Привет, удалёнка на&nbsp;свежем воздухе. Работайте с&nbsp;вдохновением. И&nbsp;с&nbsp;видом на&nbsp;любимый сад.',
        color: `${COLORS.white}`,
    },
    {
        id: 3,
        imgUrl: require('~/static/images/block-internet/smartcontrol.jpg'),
        title: 'Никого лишнего',
        subText: 'Установите умные камеры видеонаблюдения внутри дома и по периметру и участка и чувствуйте себя в безопасности.',
        color: `${COLORS.white}`,
    },
    {
        id: 4,
        imgUrl: require('~/static/images/block-internet/smarthouse.jpg'),
        title: 'Заставьте дом поумнеть',
        subText: 'А вы получите суперсилу. Газон поливается сам, а ворота открываются голосом? Это не магия — это технологии.',
        color: `${COLORS.white}`,
    },
];

export const countryHouseInternetData: IHomeData[] = [
    {
        id: 1,
        initialTypeIsRow: true,
        imgUrl: require('~/static/images/block-internet/roof.jpg'),
        title: 'Связь на городском уровне',
        subText: 'Смотрите фильмы в высоком разрешении в квартире и загородном доме.',
        color: `${COLORS.white}`,
    },
    {
        id: 2,
        imgUrl: require('~/static/images/block-internet/laptop.jpg'),
        title: 'Работа в гамаке',
        subText: 'Решайте рабочие задачи и проводите онлайн-совещания на свежем воздухе.',
        color: `${COLORS.black}`,
    },
    {
        id: 3,
        imgUrl: require('~/static/images/block-internet/house.jpg'),
        title: 'Контроль территории',
        subText: 'Установка видеонаблюдения Дом.ру по периметру загородного дома позволит чувствовать себя в безопасности.',
        color: `${COLORS.black}`,
    },
    {
        id: 4,
        imgUrl: require('~/static/images/block-internet/office.jpg'),
        title: 'Апгрейд дома',
        subText: 'Поручите полив газона и открытие ворот автоматике — «умные» гаджеты снимут с вас заботы о загородном доме.',
        color: `${COLORS.black}`,
    },
];

export const miniBannnersInternetData: TMiniBannersData[] = [
    {
        id: 1,
        initialTypeIsRow: true,
        title: '1 минута 25 секунд',
        subText: 'И&nbsp;вы&nbsp;скачаете 230 любимых песен, 600 фотографий из&nbsp;отпуска или 1&nbsp;крутой фильм',
        color: `${COLORS.white}`,
        absoluteImgOne: require('~/static/images/block-internet/clockM.png'),
        absoluteImgTwo: require('~/static/images/block-internet/clockL.png'),
        absoluteImgThree: require('~/static/images/block-internet/clockS.png'),
        background: 'linear-gradient(136.46deg, #8BD16E -7.72%, #91C2AD 68.56%, #739DA4 102.66%)',
    },
    {
        id: 2,
        title: '12 устройств \n и даже больше...',
        subText: 'Можно подключить, а&nbsp;скорость будет та&nbsp;же. Телефоны, планшеты, ТВ, приставки, камеры, колонки&nbsp;&mdash; интернета хватит всем',
        color: `${COLORS.GRAY_DARK}`,
        absoluteImgOne: require('~/static/images/block-internet/lightningM.png'),
        absoluteImgTwo: require('~/static/images/block-internet/lightningL.png'),
        absoluteImgThree: require('~/static/images/block-internet/lightningS.png'),
        background: 'linear-gradient(191.76deg, #E2E2E2 11.74%, #EDECEC 113.76%)',
    },
    {
        id: 3,
        title: '24 часа',
        subText: 'Нужно, чтобы подключить услуги после оформления заявки. Никаких сложностей&nbsp;&mdash; сделаем все сами',
        color: `${COLORS.white}`,
        absoluteImgOne: require('~/static/images/block-internet/calM.png'),
        absoluteImgTwo: require('~/static/images/block-internet/calL.png'),
        absoluteImgThree: require('~/static/images/block-internet/calS.png'),
        background: 'linear-gradient(135deg, #FF5F6D 2.88%, #FFC371 100%)',
    },
];
